/*
 * Data-visualisation tokens.
 *
 * Mantine owns the component surfaces; these are the values the charts need and
 * the component library has no opinion about: the categorical series slots, the
 * sequential ramp, and the recessive chart chrome. Both schemes are selected
 * values validated against their own surface, not an automatic inversion.
 *
 * Keyed off Mantine's own `data-mantine-color-scheme` attribute so the toggle in
 * the header drives the charts too.
 */
:root {
  /* Categorical slots 1-3 — validated all-pairs for colour-vision deficiency. */
  --series-1: #2a78d6; /* measured energy */
  --series-2: #eb6834; /* motion threshold */
  --series-3: #1baf7a; /* still threshold */

  --chart-grid: #e1e0d9;
  --chart-axis: #c3c2b7;
  --chart-muted: #898781;
  --chart-absence: #e1e0d9;

  /* Sequential blue ramp, light → dark, for the energy heatmap. */
  --seq-0: #cde2fb;
  --seq-1: #9ec5f4;
  --seq-2: #6da7ec;
  --seq-3: #3987e5;
  --seq-4: #256abf;
  --seq-5: #184f95;
  --seq-6: #0d366b;
}

[data-mantine-color-scheme='dark'] {
  --series-1: #3987e5;
  --series-2: #d95926;
  --series-3: #199e70;

  --chart-grid: #2c2c2a;
  --chart-axis: #383835;
  --chart-muted: #898781;
  --chart-absence: #2c2c2a;
}

/* The trace is the one place a monospace block is the right answer. */
.trace-line {
  display: grid;
  grid-template-columns: 74px 22px 1fr;
  gap: 8px;
  white-space: pre-wrap;
  word-break: break-all;
}

/*
 * The wiring diagram is inlined from doc/wiring-ft232rl.svg with its standalone
 * colour rules stripped, so the app supplies them here and the drawing follows
 * the in-app theme toggle rather than the operating system.
 */
.wiring-diagram {
  color: var(--mantine-color-text);
  --power: #c62f2f;
  --data: #1f6fd0;
  --muted: var(--mantine-color-dimmed);
}

[data-mantine-color-scheme='dark'] .wiring-diagram {
  --power: #e06a6a;
  --data: #5c9bec;
}

/* The file carries its own width and height; override them so it scales. */
.wiring-diagram svg {
  display: block;
  width: 100%;
  max-width: 720px;
  height: auto;
}
